import React from 'react';
import { ClipboardCheckIcon, BookOpenIcon, ShieldCheckIcon, WifiIcon, KeyRoundIcon, SmartphoneIcon, ShieldIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function IntroAssessmentPage() {
  return <div className="w-full min-h-screen bg-white flex flex-col" data-id="element-1521">
      {/* Header with logo */}
      <header className="w-full bg-[#1a0647] px-6 py-4" data-id="element-1522">
        <div className="max-w-4xl mx-auto flex items-center" data-id="element-1523">
          <Link to="/" className="flex-shrink-0" data-id="element-1524">
            <img src="https://cdn.magicpatterns.com/uploads/ddFjEWvaDfXw4mBqdFC5Gd/Caveo_Logotype_Horizontal_240x50_White_PNG.png" alt="Caveo" className="h-5" data-id="element-1525" />
          </Link>
        </div>
      </header>

      {/* Main content */}
      <div className="px-6 pt-6 pb-10" data-id="element-1526">
        <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-1527">
          {/* Heading */}
          <h1 className="text-3xl md:text-4xl font-bold text-[#111111] mb-1 tracking-tight" data-id="element-1528">
            Digital Risk Assessment
          </h1>
          <p className="text-gray-500 text-base md:text-lg mb-6" data-id="element-1529">
            Get a personalized plan in 3-4 minutes.
          </p>

          {/* Three-step process */}
          <div className="flex items-center justify-center mb-6" data-id="element-1530">
            <div className="flex flex-col items-center" data-id="element-1531">
              <div className="w-14 h-14 rounded-full border-2 border-gray-200 flex items-center justify-center bg-white" data-id="element-1532">
                <ClipboardCheckIcon size={24} className="text-gray-400" data-id="element-1533" />
              </div>
              <span className="mt-2 text-sm font-semibold text-[#111111]" data-id="element-1534">
                Assess
              </span>
            </div>

            <div className="w-10 md:w-16 h-[2px] bg-gray-200 mb-5" data-id="element-1535" />

            <div className="flex flex-col items-center" data-id="element-1536">
              <div className="w-14 h-14 rounded-full border-2 border-gray-200 flex items-center justify-center bg-white" data-id="element-1537">
                <BookOpenIcon size={24} className="text-gray-400" data-id="element-1538" />
              </div>
              <span className="mt-2 text-sm font-semibold text-[#111111]" data-id="element-1539">
                Inform
              </span>
            </div>

            <div className="w-10 md:w-16 h-[2px] bg-gray-200 mb-5" data-id="element-1540" />

            <div className="flex flex-col items-center" data-id="element-1541">
              <div className="w-14 h-14 rounded-full border-2 border-gray-200 flex items-center justify-center bg-white" data-id="element-1542">
                <ShieldCheckIcon size={24} className="text-gray-400" data-id="element-1543" />
              </div>
              <span className="mt-2 text-sm font-semibold text-[#111111]" data-id="element-1544">
                Secure
              </span>
            </div>
          </div>

          {/* What's Covered */}
          <div className="flex flex-wrap justify-center gap-3 mb-8" data-id="element-1545">
            <div className="flex items-center px-4 py-2.5 bg-white rounded-xl border border-gray-200 shadow-sm" data-id="element-1546">
              <span className="text-xl flex-shrink-0" data-id="element-1547">🏠</span>
              <span className="ml-2 text-sm font-semibold text-[#111111] whitespace-nowrap" data-id="element-1548">
                Home Network
              </span>
            </div>
            <div className="flex items-center px-4 py-2.5 bg-white rounded-xl border border-gray-200 shadow-sm" data-id="element-1549">
              <span className="text-xl flex-shrink-0" data-id="element-1550">🔐</span>
              <span className="ml-2 text-sm font-semibold text-[#111111] whitespace-nowrap" data-id="element-1551">
                Passwords
              </span>
            </div>
            <div className="flex items-center px-4 py-2.5 bg-white rounded-xl border border-gray-200 shadow-sm" data-id="element-1552">
              <span className="text-xl flex-shrink-0" data-id="element-1553">📱</span>
              <span className="ml-2 text-sm font-semibold text-[#111111] whitespace-nowrap" data-id="element-1554">
                Devices
              </span>
            </div>
            <div className="flex items-center px-4 py-2.5 bg-white rounded-xl border border-gray-200 shadow-sm" data-id="element-1555">
              <span className="text-xl flex-shrink-0" data-id="element-1556">🛡️</span>
              <span className="ml-2 text-sm font-semibold text-[#111111] whitespace-nowrap" data-id="element-1557">
                Privacy
              </span>
            </div>
          </div>

          {/* Start Assessment button */}
          <Link to="/assessment" className="bg-[#631bb7] text-white px-6 py-2.5 rounded-lg font-bold text-lg no-underline hover:bg-[#521099] transition-all shadow-md" data-id="element-1558">
            Start Assessment
          </Link>
        </div>
      </div>
    </div>;
}